import store from "../app/store";
import { createAction } from "@reduxjs/toolkit";
import { ACTION_GROUPS_CHANGED } from "./DevicesPageReducer";
import { deepCopy } from "../utils";
import { showDangerToast } from "../validation/ToastContainer";
import { securedFetch } from "../auth/authService";
import { GROUP_API } from "../vars";
import { filterGroupsForCurrentUser } from "../auth/groupAccess";

export function list() {
    return securedFetch(GROUP_API).then(response => response.json()).then((data) => {
        data = filterGroupsForCurrentUser(deepCopy(data), store.getState().auth);
        data.splice(0, 0, { id: -1, name: 'All' })
        store.dispatch(createAction(ACTION_GROUPS_CHANGED)({ groups: data }));
        return data;
    }).catch(err => {
        showDangerToast(err, "Error");
    });
}
